module.exports = __webpack_public_path__ + "static/img/2.f7c95cf9.png";